import en from './locale/en';
import es from './locale/es';
import pt from './locale/pt';
import pt_BR from './locale/pt_BR';

// Ulábot: solo se empaquetan estos idiomas para reducir el peso de la carga inicial. Ver BRANDING.md.
export default {
  en,
  es,
  pt,
  pt_BR,
};
